export default __webpack_public_path__ + "static/media/register-artwork-2.4ccc11cb.svg";